(ns vit-configurator.views.summary
  (:require [re-frame.core :as re-frame]
            [vit-configurator.events :as events]
            [vit-configurator.subs :as subs]))

(defn customizer
  []
  (let [summary-top-txt @(re-frame/subscribe [::subs/summary-top-txt])
        summary-bottom-txt @(re-frame/subscribe [::subs/summary-bottom-txt])
        summary-vote-by-mail-txt @(re-frame/subscribe [::subs/summary-vote-by-mail-txt])
        summary-absentee-hidden @(re-frame/subscribe [::subs/summary-absentee-hidden])]
    [:fieldset#summary
     [:legend "Provide text for the summary page"]
     [:label.mb-2.small {:for "summary-top-txt"} "Custom text before the list of voting options"]
     [:textarea#summary-top-txt.contained-textarea
      {:name "summary-top-txt" :value (or summary-top-txt "")
       :maxLength "300"
       :on-change (fn [evt]
                    (let [val (.. evt -target -value)]
                      (re-frame/dispatch [::events/set-summary-top-txt val])))}]
     [:label.mb-2.small {:for "summary-bottom-txt"} "Custom text after the list of voting options"]
     [:textarea#summary-bottom-txt.contained-textarea
      {:name "summary-bottom-txt" :value (or summary-bottom-txt "")
       :maxLength "300"
       :on-change (fn [evt]
                    (let [val (.. evt -target -value)]
                      (re-frame/dispatch [::events/set-summary-bottom-txt val])))}]
     [:label.mb-2.small {:for "summary-vote-by-mail-txt"} "Custom text for mail-related voting"[:span.text-note "\n(Note: Only displays if your election data is described as `mail-only: true`)"]]
     [:textarea#summary-vote-by-mail-txt.contained-textarea
      {:name "summary-vote-by-mail-txt" :value (or summary-vote-by-mail-txt "")
       :maxLength "300"
       :on-change (fn [evt]
                    (let [val (.. evt -target -value)]
                      (re-frame/dispatch [::events/set-summary-vote-by-mail-txt val])))}]
     [:label.pl-1.pt-2.pr-4 {:for "summary"} "Custom Summary Page Options"]
     [:div.labelled-checkbox-aligned
      [:label.mr-2.mb-0.small {:for "hide-summary-absentee"} "Hide Absentee Voting Option" [:span.text-note "\n(Note: Providing this option for vote by mail state partners.)"]]
      [:input#hide-summary-absentee
       {:type "checkbox" :name "hide-summary-absentee"
        :checked summary-absentee-hidden
        :on-change (fn [evt]
                     (let [hidden? (.. evt -target -checked)]
                       (re-frame/dispatch [::events/set-summary-absentee-visibility hidden?])))}]]
     ]))
